import ImageV2 from './ImageV2'

export default ImageV2
